import { GameLoader } from "../loaders/GameLoader";

type TypePromoInitData = Readonly<{
    bet: number;
    currencyFormat: {
        currency_style: "symbol" | "code" | "hidden";
        denominator: number;
        style: "money" | "number";
    };
}>;

export class PromoCommunicationService {
    private award: any = null;
    private _isPromoToolInited: boolean = false;

    private lastSentToPromoOnGameIdleOrActive: string | null = null;
    private isGameActive: boolean = true;
    private isContentVisibleInShellFeature: boolean = false;

    set isPromoToolInited(value: boolean) {
        this._isPromoToolInited = value;
        this.gameLoader.setActivePromoWidget(value);
    }

    get isPromoToolInited() {
        return this._isPromoToolInited;
    }


    constructor(
        public gameLoader: GameLoader,
        public iframe: HTMLIFrameElement,
        public isDebug: boolean
    ) {
        this.subscribe();
    }

    // fixme remove it when Awards be integrated
    temporaryHookInit(): void {
        try {
            this.promoInit({
                bet: 1,
                currencyFormat: {
                    currency_style: "symbol",
                    denominator: 100,
                    style: "money",
                },
            });
        } catch (error) {
            console.warn(`Temporary hook initialized with error: ${error}`);
        }
    }

    handleReload(): void {
        this.postToPromo("gameReload");
    }

    private subscribe(): void {
        // Listener from Shell Feature
        window.addEventListener("shell-feature-content-visible", (event: CustomEvent<boolean>) => {
            this.isContentVisibleInShellFeature = event.detail;
            this.promoOnGameIdleOrActive();
            this.promoShowBonusPopupIfExist();
            this.isContentVisibleInShellFeature ? this.promoHide() : this.promoShow();
            this.consoleLog('From Shell Feature:', 'content visible', this.isContentVisibleInShellFeature);
        });

        window.addEventListener("message", (message) => {
            if (!this.iframe || !message.data || !this.iframe.contentWindow) {
                return;
            }

            try {
                const { name, data, action } = message.data || {};

                // Promo Tool events
                if (action) {
                    this.consoleLog('From Promo', action, data);

                    switch (action) {
                        case "bonusPopupResponse":
                            this.gameBonusPopupResponse(message);
                            break;
                        case "promoInited":
                            this.isPromoToolInited = true;
                            this.promoShow();
                            this.gamePromoInited();
                            this.promoShowBonusPopupIfExist();
                            break;
                    }
                }

                // Game events
                if (name) {
                    this.consoleLog('From Game', name, data);

                    switch (name) {
                        case "widget:award_available":
                            this.award = data;
                            this.promoShowBonusPopupIfExist();
                            break;
                        case "widget:award_init":
                            this.promoInit(data);
                            break;
                        case "widget:award_bet_changed":
                            this.promoBetChanged(data);
                            break;
                        case "widget:award_on_game_idle":
                            this.isGameActive = false;
                            this.promoOnGameIdleOrActive();
                            this.promoShowBonusPopupIfExist();
                            break;
                        case "widget:award_on_game_active":
                            this.isGameActive = true;
                            this.promoOnGameIdleOrActive();
                            break;
                        case "widget:game_killed":
                            this.promoGameKilled();
                            break;
                    }
                }
            } catch (ep: any) {
                console.warn(`PostMessage transfer unavailable: ${ep.message}`);
            }
        });

        window.addEventListener("beforeunload", this.promoBeforeunload.bind(this));
    }

    // Promo Tool Actions

    private promoBeforeunload() {
        window.removeEventListener("beforeunload", this.promoBeforeunload);
        this.postToPromo("gameReload");
    }

    private promoInit(data: TypePromoInitData) {
        this.postToPromo("init", {
            bet: data.bet, // current user bet in cents
            currencyFormat: data.currencyFormat,
            widgetParams: {
                landscape: {
                    visible: true, //is widget visible always
                    initialVisible: false, // is widget visible on start
                },
                portrait: {
                    visible: true, //is widget visible always
                    initialVisible: false, // is widget visible on start
                },
            }
        });
    }

    private promoShow() {
        this.postToPromo("show");
    }

    private promoHide() {
        this.postToPromo("hide");
    }

    private promoBetChanged(data: any) {
        this.postToPromo("onBetChanged", data.bet);
    }

    private promoShowBonusPopupIfExist() {
        if (!this.award || this.isGameActive || this.isContentVisibleInShellFeature || !this.isPromoToolInited) return;

        this.award.source = this.award?.source || this.award?.event || "operator";
        this.postToPromo("showBonusPopup", {
            type: "award",
            data: this.award,
        });
    }

    private promoOnGameIdleOrActive() {
        const currentState = (!this.isContentVisibleInShellFeature && !this.isGameActive)
            ? "onGameIdle"
            : "onGameActive";

        if (this.lastSentToPromoOnGameIdleOrActive !== currentState) {
            this.postToPromo(currentState);
            this.lastSentToPromoOnGameIdleOrActive = currentState;
        }
    }

    private promoGameKilled() {
        this.postToPromo("gameKilled");
    }

    private postToPromo = (action: any, payload: any = {}) => {
        const message = { from: "GAME", to: "PROMO", action, payload };
        this.consoleLog("Message to Promo", message, payload);
        window.parent.postMessage(message, "*");
    };

    // Game Actions

    private gameBonusPopupResponse(data: any) {
        this.postGame("widget:award_claimed", this.award);
        this.award = null;
    }

    private gamePromoInited() {
        this.postGame("widget:award_promo_inited");
    }

    private postGame = (name: string, data: any = '') => {
        if (!this.iframe || !this.iframe.contentWindow) {
            return;
        }

        const message = { name, data };
        this.consoleLog("Message to Game", message, data);
        this.iframe.contentWindow.postMessage(message, "*");
    }

    // *****
    private consoleLog = (place: string, message: any, data: any = '') => {
        if (this.isDebug) {
            console.log(place, message,data );
        }
    }
}
